import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { auditSelectors } from '../../../../state/ducks/audit/selectors';
import { AuditLogFilters } from '../../../../models/entities/audit/auditLog';
import { RootState } from '../../../../state/store/store';
import AuditDashboardPage from '../../Audit/AuditDashboardPageRefactored';
import {
    PlatformGridWrapper,
    PlatformHeaderWrapper,
    PlatformPageSubtitle,
    PlatformPageTitle,
    PlatformPageWrapper
} from '../shared/platformPageStyles';

type Props = {
    loading: boolean;
    groupedAuditLogs: ReturnType<typeof auditSelectors.groupedAuditLogs>;
    groupedPagination: ReturnType<typeof auditSelectors.groupedPagination>;
    currentFilters: ReturnType<typeof auditSelectors.currentFilters>;
    fetchMetadata: () => void;
    fetchGroupedAuditLogs: (filters?: AuditLogFilters, loadMore?: boolean) => void;
    setUsePlatformAudit: (value: boolean) => void;
};

const PlatformAuditPageConnected = ({
    loading,
    groupedAuditLogs,
    groupedPagination,
    currentFilters,
    fetchMetadata,
    fetchGroupedAuditLogs,
    setUsePlatformAudit
}: Props) => {
    useEffect(() => {
        setUsePlatformAudit(true);
        fetchMetadata();
        fetchGroupedAuditLogs({}, false);
        return () => setUsePlatformAudit(false);
    }, [setUsePlatformAudit, fetchMetadata, fetchGroupedAuditLogs]);

    const localization = {
        title: 'Activity history',
        filter: { filter_btn: 'Filter' }
    };

    return (
        <PlatformPageWrapper>
            <PlatformHeaderWrapper>
                <PlatformPageTitle>Activity history</PlatformPageTitle>
                <PlatformPageSubtitle>
                    Every change recorded across all organizations and users in CargoZone.
                </PlatformPageSubtitle>
            </PlatformHeaderWrapper>
            <PlatformGridWrapper>
                <AuditDashboardPage
                    localization={localization}
                    showLoader={loading}
                    loading={loading}
                    fetchGroupedAuditLogs={fetchGroupedAuditLogs}
                    fetchMetadata={fetchMetadata}
                    groupedAuditLogs={groupedAuditLogs}
                    groupedPagination={groupedPagination}
                    currentFilters={currentFilters}
                />
            </PlatformGridWrapper>
        </PlatformPageWrapper>
    );
};

const mapState = (state: RootState) => ({
    loading: auditSelectors.loading(state),
    groupedAuditLogs: auditSelectors.groupedAuditLogs(state),
    groupedPagination: auditSelectors.groupedPagination(state),
    currentFilters: auditSelectors.currentFilters(state)
});

const mapDispatch = (dispatch: any) => ({
    fetchMetadata: () => dispatch.audit.fetchMetadata(),
    fetchGroupedAuditLogs: (filters?: AuditLogFilters, loadMore = false) => dispatch.audit.fetchGroupedAuditLogs(filters, loadMore),
    setUsePlatformAudit: (value: boolean) => dispatch.platformSuperAdmin.setUsePlatformAudit(value)
});

export default connect(mapState, mapDispatch)(PlatformAuditPageConnected);
